module.exports = __webpack_public_path__ + "static/media/content.04bd6e3a.png";